module.exports = __webpack_public_path__ + "img/contact_us_banner.d3291bb7.jpg";